import { Program } from 'hevy-shared';

export interface ClientProgram extends Program {
  client_id: string;
}

export const ProgramIsClientProgram = (program: Program): program is ClientProgram => {
  return !!program.client_id;
};
